import { render } from "./DraftBills.vue?vue&type=template&id=f9bfd8aa"
import script from "./DraftBills.vue?vue&type=script&lang=js"
export * from "./DraftBills.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__